module.exports = __webpack_public_path__ + "static/media/logo_whatsapp_verde.6af811ad.svg";